import axiosInstance from "../utils/axiosConfig";
import { useEffect, useState, useCallback } from "react";
import { Link, useParams, useHistory} from "react-router-dom";
import BrAvatar from "./Avatar";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Button from "../Input/Button";
import ProfileAccordions from "./ProfileAccordions";
import SelectAvatarModal from "../Modals/SelectAvatarModal";
import SelectNationalityModal from "../Modals/SelectNationalityModal";
import CountriesMap from "../Profile/CountriesMap";
import HiddenProfileMessage from "./HiddenProfileMessage";
import Typography from "@material-ui/core/Typography";


export default function Profile(props) {
    const { user, isParent, showNotification, theme } = props;
    const { userId } = useParams();
    const history = useHistory();
    
    const useStyles = makeStyles({
        root: {
            minWidth: 275,
            minHeight: 535,
        },
        pageBackground: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `url(${theme.backgroundLogo}) no-repeat center center fixed`,
            backgroundSize: "cover",
            opacity: 0.6,
            zIndex: -1,
        },
        mainContainer: {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingTop: "20px",
            position: "relative",
        },
        contentWrapper: {
            width: "100%",
            maxWidth: "1600px",
            margin: "180px auto 0 auto",
            position: "relative",
            zIndex: 1,
        },
        bullet: {
            minHeight: "100px",
            margin: "0 2px",
            transform: "scale(0.8)",
        },
        title: {
            fontSize: 32,
            fontFamily: "GoodUnicorn",
            color: theme.primaryColor,
            textAlign: "left",
            position: "fixed",
            top: "130px", // adjust down to leave ~50px gap above cards once container padding is included
            // Align with left edge of first grid item (accounts for Grid spacing padding)
            left: "calc((100vw - min(1600px, calc(100vw - 48px))) / 2 + 36px)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            height: "40px",
            lineHeight: "40px",
        },
        avatar: {
            marginLeft: "35%",
            marginTop: "5%",
            width: "20%",
            height: "20%",
        },
        pos: {
            marginBottom: 12,
        },
        rewardCard: {
            backgroundColor: "#efeaff",
        },
        heading: {
            fontSize: 16,
            flexBasis: "33.33%",
            flexShrink: 0,
        },
        hobbyCard: {
            backgroundColor: "#dbf2d1",
        },
        videosCard: {
            backgroundColor: "#ffe5e5",
        },
        videoCardContainer: {
            margin: "4px",
            width: "80%",
            height: "75%",
        },
        playIcon: {
            color: "#eb4c8a",
            cursor: "pointer",
            position: "absolute",
            top: "20%",
            left: "25%",
            transform: "translate(-25%, -25%)",
        },
        imagesCard: {
            backgroundColor: "#d6f1fe",
        },
        images: {
            margin: "4px",
        },
        subCardReward: {
            width: "50%",
            minHeight: "40px",
            marginTop: "20%",
            marginLeft: "10%",
            backgroundColor: "#937cff",
        },
        subCardHobbies: {
            width: "50%",
            minHeight: "40px",
            marginTop: "20%",
            marginLeft: "10%",
            backgroundColor: "#4bbe0d",
        },
        hobbyIcon: {
            width: "80%",
            minHeight: "40px",
            marginTop: "20%",
            backgroundColor: "#dbf2d1",
        },
        hobbyLink: {
            marginBottom: "-10px",
            color: "#4bbe0d",
        },
        subCardVideos: {
            width: "50%",
            minHeight: "40px",
            marginTop: "20%",
            marginLeft: "10%",
            backgroundColor: "#fe787f",
        },
        subCardImages: {
            width: "50%",
            minHeight: "40px",
            marginTop: "20%",
            marginLeft: "10%",
            backgroundColor: "#2cbcf8",
        },
        actionBtn: {
            marginLeft: "0%",
            width: "50%",
            height: "20%"
        },
        dashboardButton: {
            position: "fixed",
            top: "130px", // adjust down to leave ~50px gap above cards once container padding is included
            // Align with right edge of last grid item (accounts for Grid spacing padding)
            right: "calc((100vw - min(1600px, calc(100vw - 48px))) / 2 + 36px)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            height: "40px",
        },
        cardTopPadding: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            paddingTop: "20px",
            paddingBottom: "20px",
        },
        leftCardContent: {
            marginTop: "-120px",
        }
    });
    
    const classes = useStyles();
    
    const [profileData, setProfileData] = useState({
        profileUser: null, // Changed from {} to null to make loading state clearer
        myFriends: [],
        myPendingFriends: [],
        userHobbies: [],
        userImages: [],
        userVideos: [],
        awardCount: 0
    });
    
    const [showAvatarModal, setShowAvatarModal] = useState(false);
    const [showNationalityModal, setShowNationalityModal] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0); // Force re-render trigger
    const [isRequestingFriend, setIsRequestingFriend] = useState(false); // Loading state
    const [isCancelingRequest, setIsCancelingRequest] = useState(false); // Cancel loading state
    
    const fetchProfileData = useCallback(async () => {
        try {
            const [userProfileResult, myFriendsResult, myPendingFriendsResult, hobbiesResult, imagesResult, videosResult] = await Promise.all([
                axiosInstance.get(`/user/${userId}`),
                axiosInstance.get(`/friends/${user.id}`), // Get MY friends, not profile user's friends
                axiosInstance.get(`/pending_friends/${user.id}`), // Get MY pending requests, not profile user's
                axiosInstance.get(`/hobbies/${userId}`),
                axiosInstance.get(`/uploads/${userId}?type=image`),
                axiosInstance.get(`/uploads/${userId}?type=video`),
            ]);
            
            console.log("🚀 ~ fetchProfileData ~ userProfileResult:", userProfileResult.data);
            console.log("🚀 ~ fetchProfileData ~ myFriendsResult:", myFriendsResult.data);
            console.log("🚀 ~ fetchProfileData ~ myPendingFriendsResult:", myPendingFriendsResult.data);
            console.log("🚀 ~ fetchProfileData ~ Current user:", user);
            console.log("🚀 ~ fetchProfileData ~ Profile user ID:", userId);
            
            // Ensure we have valid data before setting state
            if (!userProfileResult.data || !userProfileResult.data.id) {
                console.error("🚀 ~ fetchProfileData ~ Invalid profile user data:", userProfileResult.data);
                throw new Error('Invalid profile user data received');
            }
            
            const awardCount = userProfileResult.data.posts
                ? userProfileResult.data.posts.reduce((prev, current) => prev + current.awards.length, 0)
                : 0;
            
            setProfileData({
                profileUser: userProfileResult.data || {},
                myFriends: myFriendsResult.data || [], // My friends list
                myPendingFriends: myPendingFriendsResult.data || [], // My pending requests
                userHobbies: hobbiesResult.data || [],
                userImages: imagesResult.data || [],
                userVideos: videosResult.data || [],
                awardCount
            });
            
            // Force component re-render
            setRefreshKey(prev => prev + 1);
        } catch (error) {
            console.error("Error fetching profile data:", error);
            showNotification("Failed to load profile data", "error");
            
            // Set minimal safe state to prevent crashes
            setProfileData(prev => ({
                ...prev,
                profileUser: prev.profileUser || {},
                myFriends: prev.myFriends || [],
                myPendingFriends: prev.myPendingFriends || []
            }));
        }
    }, [userId, user, showNotification]);
    
    useEffect(() => {
        fetchProfileData();
    }, [fetchProfileData]);
    
    // Effect to debug state changes
    useEffect(() => {
        console.log("🚀 ~ Profile ~ profileData state changed:", {
            myFriendsCount: profileData.myFriends?.length || 0,
            myPendingFriendsCount: profileData.myPendingFriends?.length || 0,
            profileUserId: profileData.profileUser?.id || 'not_set',
            refreshKey: refreshKey,
            timestamp: new Date().toISOString()
        });
    }, [profileData, refreshKey]);
    
    const requestFriend = async () => {
        if (isRequestingFriend) return; // Prevent double-clicks
        
        setIsRequestingFriend(true);
        try {
            console.log("🚀 ~ requestFriend ~ Sending friend request to:", userId);
            const result = await axiosInstance.post(`/friends/${userId}`);
            console.log("🚀 ~ requestFriend ~ API Response:", {
                status: result.status,
                data: result.data,
                profileUserId: userId
            });
            
            // Check for both 200 and 201 status codes (201 is returned for successful creation)
            if (result.status === 200 || result.status === 201) {
                showNotification("Friend requested, awaiting parental approval", "success");
                console.log("🚀 ~ requestFriend ~ Refreshing profile data after successful request");
                // Wait a moment before refreshing to ensure backend has processed
                setTimeout(() => {
                    fetchProfileData();
                }, 500);
            } else {
                console.error("Unexpected status code:", result.status);
                showNotification("Failed to send friend request", "error");
            }
        } catch (error) {
            console.error("Error in requestFriend:", error);
            if (error.response && error.response.data && error.response.data.error) {
                showNotification(error.response.data.error, "error");
            } else {
                showNotification("Failed to send friend request", "error");
            }
        } finally {
            setIsRequestingFriend(false);
        }
    };
    
    const cancelRequest = async (targetId) => {
        if (isCancelingRequest) return; // Prevent double-clicks
        
        setIsCancelingRequest(true);
        try {
            console.log("🚀 ~ cancelRequest ~ Canceling friend request for:", targetId);
            const result = await axiosInstance.delete(`/friends/${user.id}/${targetId}`);
            console.log("🚀 ~ cancelRequest ~ API Response:", {
                status: result.status,
                data: result.data,
                userId: user.id,
                targetId: targetId
            });
            
            if (result.status === 200) {
                showNotification("Friend request canceled", "success");
                console.log("🚀 ~ cancelRequest ~ Refreshing profile data after successful cancel");
                // Wait a moment before refreshing to ensure backend has processed
                setTimeout(() => {
                    fetchProfileData(); // Refresh data to update UI
                }, 500);
            } else {
                console.error("Unexpected status code for cancel:", result.status);
                showNotification("Failed to cancel friend request", "error");
            }
        } catch (error) {
            console.error('Error canceling friend request:', error);
            if (error.response && error.response.data && error.response.data.error) {
                showNotification(error.response.data.error, "error");
            } else {
                showNotification("Failed to cancel friend request", "error");
            }
        } finally {
            setIsCancelingRequest(false);
        }
    };
    
    const FriendActions = () => {
        const { profileUser, myFriends, myPendingFriends } = profileData;
        
        // Early return if data is not loaded yet
        if (!profileUser || !profileUser.id || !Array.isArray(myFriends) || !Array.isArray(myPendingFriends)) {
            console.log("🚀 ~ FriendActions ~ Data still loading:", {
                hasProfileUser: !!profileUser,
                hasProfileUserId: !!(profileUser && profileUser.id),
                myFriendsType: typeof myFriends,
                myPendingFriendsType: typeof myPendingFriends,
                isMyFriendsArray: Array.isArray(myFriends),
                isMyPendingFriendsArray: Array.isArray(myPendingFriends)
            });
            return <div style={{ textAlign: "center", padding: "20px" }}>Loading friend data...</div>;
        }
        
        if (isParent || user.isMentor || (user?.settings && user?.settings?.profile_hidden === 1)) {
            return null;
        }
        
        if (!isParent && profileUser.settings && profileUser.settings.profile_hidden === 1) {
            return <div style={{ textAlign: "center", width: "100%" }}>This user does not accept friend requests.</div>;
        }
        
        const isFriend = myFriends.some(friend => friend.id === profileUser.id);
        const isPendingFriend = myPendingFriends.some(friend => friend.id === profileUser.id);
        
        console.log("🚀 ~ FriendActions ~ Re-render triggered:", {
            refreshKey,
            profileUserId: profileUser.id,
            isFriend,
            isPendingFriend,
            pendingCount: myPendingFriends.length
        });
        
        // Debug logging
        console.log("🚀 ~ FriendActions ~ Debug:", {
            profileUserId: profileUser.id,
            currentUserId: user.id,
            myFriendsCount: myFriends.length,
            myPendingFriendsCount: myPendingFriends.length,
            isFriend: isFriend,
            isPendingFriend: isPendingFriend,
            myFriendIds: myFriends.map(f => f.id),
            myPendingFriendIds: myPendingFriends.map(f => f.id),
            myFriendsData: myFriends,
            myPendingFriendsData: myPendingFriends
        });
        
        // If they're already friends, show Chat button.
        if (!isParent && isFriend) {
            return (
                <Link style={{ textDecoration: "none" }} to={`/messenger/${userId}/${userId}`}>
                    <div style={{ textAlign: "center", width: "100%" }}>
                        <Button theme={theme} className={classes.actionBtn}>Chat</Button>
                    </div>
                </Link>
            );
        }
        
        // If friend request is pending, show pending state with cancel option
        if (!isParent && isPendingFriend) {
            return (
                <div style={{ textAlign: "center", width: "100%", marginTop: "10px" }}>
                    <div style={{ 
                        marginBottom: "10px", 
                        color: theme.primaryColor,
                        fontSize: "14px",
                        fontWeight: "bold"
                    }}>
                        Friend Request Sent
                    </div>
                    <div style={{ 
                        marginBottom: "10px", 
                        color: "#666",
                        fontSize: "12px"
                    }}>
                        Waiting for parental approval
                    </div>
                    <Button 
                        theme={theme} 
                        onClick={() => cancelRequest(profileUser.id)} 
                        className={classes.actionBtn}
                        disabled={isCancelingRequest}
                    >
                        {isCancelingRequest ? "Canceling..." : "Cancel Request"}
                    </Button>
                </div>
            );
        }
        
        // Default: Show Request Friend button
        return (
            <div style={{ textAlign: "center", width: "100%", marginTop: "10px" }}>
                <Button 
                    theme={theme} 
                    onClick={requestFriend} 
                    className={classes.actionBtn}
                    disabled={isRequestingFriend}
                >
                    {isRequestingFriend ? "Sending..." : "Request Friend"}
                </Button>
            </div>
        );
    };
    
    const calculateAge = (dob) => {
        const ageDifMs = Date.now() - new Date(dob).getTime();
        const ageDate = new Date(ageDifMs);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    };
    
    const { profileUser, awardCount } = profileData;
    console.log("🚀 ~ Profile ~ profileUser:", profileUser);
    /*
     * Button Visibility Logic Summary:
     * - "Change Avatar" & "Nationality": Only shown when viewing YOUR OWN profile as a child
     * - "Request Friend" / "Chat": Only shown when viewing SOMEONE ELSE'S profile as a child
     * - Parents don't see friend action buttons
     */
    console.log("🚀 ~ Profile ~ Button visibility check:", {
        profileUserId: profileUser?.id,
        currentUserId: user.id,
        urlUserId: parseInt(userId),
        isOwner: profileUser?.id === user.id,
        isKid: user.isKid,
        hasKidRole: user.roles?.some(role => role.id === 1),
        userRoles: user.roles?.map(role => ({id: role.id, name: role.name})) || [],
        isParent: isParent,
        shouldShowOwnerButtons: (profileUser?.id === user.id && !isParent && (user.isKid || user.roles?.some(role => role.id === 1) || user.roles?.some(role => role.name === "child") || (!user.roles?.some(role => role.name === "parent" || role.name === "mentor")))),
        shouldShowFriendActions: (!isParent && profileUser?.id !== user.id),
        viewingOwnProfile: profileUser?.id === user.id,
        viewingSomeoneElse: profileUser?.id !== user.id,
        nationalityButtonCondition: (profileUser?.id === user.id && !isParent && (user.isKid || user.roles?.some(role => role.id === 1) || user.roles?.some(role => role.name === "child") || (!user.roles?.some(role => role.name === "parent" || role.name === "mentor"))))
    });
    
    const navigateToDashboard = () => {
        history.push("/dashboard/home");
    };
    
    // Helper function to get the appropriate nationality (child's nationality when parent is logged in)
    // Use profileUser.nationality (from fresh API fetch) which includes updated nationality
    const getNationality = () => {
        // profileUser comes from fresh API fetch (/user/${userId}) which includes nationality
        // This ensures parents see updated nationality when impersonating child
        return profileUser?.nationality ?? 'US';
    };
    
    // Show loading state if profile data is not ready
    if (!profileUser || !profileUser.id) {
        return (
            <>
                <div className={classes.pageBackground} />
                <div className={classes.mainContainer}>
                    <div className={classes.contentWrapper}>
                        <Typography className={classes.title}>
                            Profile
                        </Typography>
                        <div style={{ textAlign: "center", padding: "50px" }}>
                            <div>Loading profile...</div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    
    // Add this after destructuring profileData
    if (profileUser.settings?.profile_hidden === 1 && 
        user.id !== profileUser.id && // Allow the profile owner to see their own profile
        !user.isMentor) { // Allow mentors to see all profiles
        console.log("🚀 ~ file: Profile.jsx:256 ~ Profile ~ profileUser.settings.profile_hidden === 1:", profileUser.settings.profile_hidden === 1);
        return <HiddenProfileMessage theme={theme} history={history} />;
    } else {
        return (
            <>
                <div className={classes.pageBackground} />
                <div className={classes.mainContainer}>
                    <div className={classes.contentWrapper}>
                        <Grid container spacing={3} justifyContent="center">
                            <Grid item xs={12} sm={6} md={5} lg={4}>
                                <Card raised className={`${classes.root} ${classes.cardTopPadding}`}>
                                    <div className={classes.leftCardContent}>
                                        <div style={{ textAlign: "center", margin: "5px", fontWeight: "bold" }}>
                                        {(() => {
                                            // Display logic: Show selected child's name when parent is impersonating
                                            if (isParent) {
                                                try {
                                                    const selectedChildSettings = JSON.parse(
                                                        window.localStorage.getItem('SELECTED_CHILD_SETTINGS') || '{}'
                                                    );
                                                    // Use the selected child's name if available, otherwise fall back to "Parent"
                                                    const childName = selectedChildSettings?.name;
                                                    if (childName) {
                                                        return childName;
                                                    }
                                                } catch (error) {
                                                    console.warn('Profile: Error parsing selected child settings:', error);
                                                }
                                                return "Parent";
                                            }
                                            // Default behavior for non-parent users
                                            return profileUser.name || "Loading...";
                                        })()}
                                    </div>
                                    
                                    {profileUser.dob && (
                                        <div style={{ textAlign: "center", margin: "5px", fontSize: "14px" }}>
                                            {calculateAge(profileUser.dob) + " Years Old"}
                                        </div>
                                    )}
                                    
                                    {profileUser.avatar && (
                                        <div style={{ display: "flex", justifyContent: "center", marginTop: "10px", marginBottom: "10px" }}>
                                            <BrAvatar
                                                avatarStyles={{ width: "120px", height: "120px" }}
                                                user={profileUser}
                                                theme={theme}
                                            />
                                        </div>
                                    )}
                                    {/* Only show Change Avatar button if viewing your own profile as a child user (NOT when parent is impersonating) */}
                                    {profileUser?.id === user.id && !isParent && (
                                        // Show "Change Avatar" button only for actual child users, not parents impersonating children
                                        // Use multiple checks for robustness: isKid property, role id, role name, or absence of parent/mentor roles
                                        user.isKid || 
                                        user.roles?.some(role => role.id === 1) || 
                                        user.roles?.some(role => role.name === "child") ||
                                        (!user.roles?.some(role => role.name === "parent" || role.name === "mentor"))
                                    ) && (
                                        <div style={{ textAlign: "center", width: "100%", marginTop: 5 }}>
                                            <Button
                                                theme={theme}
                                                onClick={() => setShowAvatarModal(true)}
                                                className={classes.actionBtn}
                                            >
                                                Change Avatar
                                            </Button>
                                        </div>
                                    )}
                                    
                                    {/* Only show friend actions when viewing someone else's profile (not your own) and not as parent */}
                                    {!isParent && profileUser?.id !== user.id && (
                                        <FriendActions key={`friend-actions-${refreshKey}`} />
                                    )}
                                    
                                    <div style={{ textAlign: "center", width: "100%", marginTop: 5 }}>
                                        {/* Only show Nationality button if viewing your own profile as a child user (NOT when parent is impersonating) */}
                                        {profileUser?.id === user.id && !isParent && (
                                            // Show "Nationality" button only for actual child users, not parents impersonating children
                                            // Use multiple checks for robustness: isKid property, role id, role name, or absence of parent/mentor roles
                                            user.isKid || 
                                            user.roles?.some(role => role.id === 1) || 
                                            user.roles?.some(role => role.name === "child") ||
                                            (!user.roles?.some(role => role.name === "parent" || role.name === "mentor"))
                                        ) && (
                                            <div style={{ textAlign: "center", width: "100%", marginTop: 5, marginBottom: 5 }}>
                                                <Button
                                                    theme={theme}
                                                    onClick={() => setShowNationalityModal(true)}
                                                    className={classes.actionBtn}
                                                >
                                                    Nationality
                                                </Button>
                                            </div>
                                        )}
                                        
                                        {profileUser && (
                                            <>
                                                <div style={{ marginTop: "15px" }}>
                                                    <img
                                                        src={`https://flagcdn.com/32x24/${getNationality().toLowerCase()}.png`}
                                                        srcSet={`https://flagcdn.com/48x36/${getNationality().toLowerCase()}.png 2x,
                                                            https://flagcdn.com/64x48/${getNationality().toLowerCase()}.png 3x`}
                                                        width="32"
                                                        height="24"
                                                        alt={`Flag of ${getNationality()}`}
                                                    />
                                                </div>
                                                {" "}
                                                {CountriesMap[getNationality().toUpperCase()]}
                                            </>
                                        )}
                                    </div>
                                    </div>
                                </Card>
                            </Grid>
                            
                            <Grid item xs={12} sm={6} md={7} lg={7}>
                                <Card raised className={`${classes.root} ${classes.cardTopPadding}`}>
                                    <ProfileAccordions
                                        userId={userId}
                                        user={profileUser}
                                        awardCount={awardCount}
                                    />
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                    <SelectAvatarModal
                        user={profileUser}
                        theme={theme}
                        open={showAvatarModal}
                        handleClose={() => setShowAvatarModal(false)}
                    />
                    <SelectNationalityModal
                        user={profileUser}
                        theme={theme}
                        open={showNationalityModal}
                        handleClose={() => setShowNationalityModal(false)}
                    />
                </div>
                
                <Typography className={classes.title}>
                    Profile
                </Typography>
                
                <div className={classes.dashboardButton}>
                    <Button
                        onClick={navigateToDashboard}
                        theme={theme}
                        style={{ 
                            fontWeight: 'bold',
                            padding: '8px 20px',
                            fontSize: '16px'
                        }}
                    >
                        Back To Dashboard
                    </Button>
                </div>
            </>
        );
    }
}